// extracted by mini-css-extract-plugin
module.exports = {"image-container":"style_image-container__1TAr2"};